import { render, staticRenderFns } from "./BetaDecayNeutrinoViz.vue?vue&type=template&id=28a6d386&scoped=true"
import script from "./BetaDecayNeutrinoViz.vue?vue&type=script&lang=js"
export * from "./BetaDecayNeutrinoViz.vue?vue&type=script&lang=js"
import style0 from "./BetaDecayNeutrinoViz.vue?vue&type=style&index=0&id=28a6d386&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a6d386",
  null
  
)

export default component.exports